module.exports = __webpack_public_path__ + "static/media/Yuma Weaving Prt 2 V2.7a1144c8.mp4";